'use strict';

// Store interval references for each timer
const timerIntervals = {};

const BREAKPOINTS = {
    sm: 441
}

/**
 * Starts a countdown timer and displays it on the screen.
 *
 * @param {string} id - A unique identifier for the timer.
 * @param {number} timeout - The timeout duration in minutes.
 * @param {string} [message='Time remaining:'] - The message to display alongside the timer (can include HTML).
 * @param {string} [expiredMessage='Timer Expired'] - The message to display when the timer expires (can include HTML).
 */
function start(id, timeout, message = 'Time remaining:', expiredMessage = 'Timer Expired') {
    const timerId = `timer-${id}`;
    let countDownDate = null;

    if (document.getElementById(id)) {
        console.warn(`Timer with ID "${id}" already exists. Only one timer per ID is allowed.`);
        return;
    }

    if (sessionStorage[timerId]) {
        countDownDate = parseInt(sessionStorage[timerId], 10);
    } else {
        const futureTime = new Date();
        futureTime.setMinutes(futureTime.getMinutes() + timeout);
        sessionStorage[timerId] = futureTime.getTime();
        countDownDate = futureTime.getTime();
    }

    const existingTimers = document.querySelectorAll('.ecux-timer');
    const topOffset = 1 + existingTimers.length * 5;

    const timerHTML = `<div id="${id}" class="ecux-timer min-w-25 max-w-50 rounded-lg align-content-center align-items-center d-flex flex-row"
        style="position: fixed; top: ${topOffset}rem; right: 1rem; padding: 14px 12px; gap: 8px; background: #CCE0FF; z-index: 1050;">
        <div class="icon icon-info-filled --icon-xs">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Size=L, Fill=On">
                    <path
                        id="Union" d="M22.339 34.311H25.961V22H22.339V34.311ZM24.0015 18.724C24.5895 18.724 25.082 18.53 25.479
                        18.142C25.8756 17.754 26.074 17.2733 26.074 16.7C26.074 16.077 25.8753 15.5673 25.478 15.171C25.0806 14.7743
                        24.5883 14.576 24.001 14.576C23.3923 14.576 22.8943 14.7743 22.507 15.171C22.1196 15.5673 21.926 16.0723
                        21.926 16.686C21.926 17.271 22.125 17.757 22.523 18.144C22.9206 18.5307 23.4135 18.724 24.0015 18.724ZM24.017
                        44.7065C21.1436 44.7065 18.452 44.1667 15.942 43.087C13.432 42.007 11.2363 40.5263 9.35496 38.645C7.47362
                        36.7637 5.99296 34.5682 4.91296 32.0585C3.83329 29.5485 3.29346 26.8553 3.29346 23.979C3.29346 21.1027 3.83329
                        18.4082 4.91296 15.8955C5.99296 13.3832 7.47212 11.1942 9.35046 9.32849C11.2288 7.46282 13.4236 5.98582 15.935
                        4.89749C18.4463 3.80915 21.1408 3.26498 24.0185 3.26498C26.8965 3.26498 29.5928 3.80848 32.1075 4.89548C34.6225
                        5.98215 36.812 7.45715 38.676 9.32048C40.5403 11.1835 42.0161 13.3743 43.1035 15.893C44.1911 18.4117 44.735
                        21.1095 44.735 23.9865C44.735 26.8628 44.1908 29.5558 43.1025 32.0655C42.0141 34.5752 40.5371 36.7665 38.6715
                        38.6395C36.8058 40.5121 34.6155 41.9915 32.1005 43.0775C29.5851 44.1635 26.8906 44.7065 24.017 44.7065Z"
                        fill="#0A0A0A">
                    </path>
                </g>
            </svg>
        </div>
        <div id="${id}-message" class="sub-title-sm w-max-content">${message} <span id="${id}-time">00:00</span></div>
    </div>`;

    if (window.innerWidth > BREAKPOINTS.sm) {
        document.body.insertAdjacentHTML('beforeend', timerHTML);
    } else {
        var mobileTimerElement = document.querySelector('.checkoutPageHeaderLayout');
        mobileTimerElement.insertAdjacentHTML('beforebegin', timerHTML);
    }

    // Start the countdown interval
    timerIntervals[id] = setInterval(() => {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const displaySeconds = seconds < 10 ? `0${seconds}` : seconds;

        if (distance > 0) {
            document.getElementById(`${id}-time`).textContent = `${displayMinutes}:${displaySeconds} mins`;
        } else {
            clearInterval(timerIntervals[id]);
            delete timerIntervals[id];
            sessionStorage.removeItem(timerId);

            console.info(`Timer with ID "${id}" has expired. ecux.timer.expired.${id}`);
            const event = new CustomEvent(`ecux.timer.expired.${id}`, { detail: { id } });
            document.dispatchEvent(event);

            document.getElementById(`${id}-message`).innerHTML = expiredMessage;
        }
    }, 1000);
}

/**
 * Resets an existing timer by deleting the expired timer (if any) and creating a new instance.
 *
 * @param {string} id - The unique identifier of the timer to reset.
 * @param {number} timeout - The timeout duration in minutes.
 */
function reset(id, timeout) {
    distory(id);
    start(id, timeout);
}

/**
 * Deletes an existing timer from the DOM and sessionStorage.
 *
 * @param {string} id - The unique identifier of the timer to delete.
 */
function distory(id) {
    const timerId = `timer-${id}`;
    const timerElement = document.getElementById(id);

    if (!timerElement) {
        console.warn(`Timer with ID "${id}" does not exist. Cannot delete.`);
        return;
    }

    if (timerIntervals[id]) {
        clearInterval(timerIntervals[id]);
        delete timerIntervals[id];
    }

    timerElement.remove();
    sessionStorage.removeItem(timerId);

    console.info(`Timer with ID "${id}" has been deleted.`);
}

module.exports = {
    start: start,
    reset: reset,
    distory: distory
};
